import {Biscuit} from "../../utils";
import React from "react";

type Props = {
    onChange: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void,
    value: boolean,
    name: string,
    label?: string,
    checkBoxStyle?: object,
    labelStyle?: object,
    switchStyle?: object,
    largeWidth?: string|number|undefined,
    mediumWidth?: string|number|undefined,
    smallWidth?: string|number|undefined,
    paddle?: boolean,
    disabled?: boolean,
    checkBoxLabel?: string,
    notTiny?: boolean,
    id?: string|null
}
 const SwitchPaddle = ({onChange, value, name, label, checkBoxStyle, labelStyle, switchStyle, largeWidth, mediumWidth, smallWidth, paddle, disabled, checkBoxLabel, notTiny}: Props) => {
    if(typeof labelStyle === 'undefined'){
        labelStyle = {};
    }
    if(typeof switchStyle !== 'undefined'){
        switchStyle = {};
    }
    if(typeof largeWidth === 'undefined'){
        largeWidth = 10;
    }
     if(typeof mediumWidth === 'undefined'){
         mediumWidth = 10;
     }
     if(typeof smallWidth === 'undefined'){
         smallWidth = 12;
     }
     if(typeof paddle === 'undefined'){
       paddle = true;
     }
     if(typeof notTiny === 'undefined'){
         notTiny = false;
     }
     if (typeof checkBoxLabel === 'undefined'){
         checkBoxLabel = "";
     }
     if (typeof checkBoxStyle === 'undefined'){
         checkBoxStyle = {};
     }
    // @ts-ignore
     return (
        <>
            <div className={"inb-form-group column label-float-left large-"+largeWidth+" medium-"+mediumWidth+" small-"+smallWidth} style={checkBoxStyle}>
                <label className="inb-form__controlLabel" style={labelStyle}>{label}</label>
                <div className={"switch " +(notTiny?"":"tiny ") + "inb-form__controllClass"}  style={switchStyle}>
                    <input
                        className={paddle?"switch-input ":""}
                        id={name + "Switch"}
                        disabled={disabled}
                        type="checkbox"
                        name={name}
                        checked={value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e,name)}/>
                    {paddle && <>
                    <label className={"switch-paddle switch-paddle-" + Biscuit.get('user.client_id')} htmlFor={name + "Switch"}>
                        <span className="show-for-sr">Toggle content</span>
                    </label>
                    </>}
                    {checkBoxLabel !== '' &&
            <><label htmlFor={name + "Switch"}>
                        <span>{checkBoxLabel}</span>
                    </label></>}
                </div>
            </div>
        </>
    )
}

export default SwitchPaddle;